// src/pages/ManageContent.js
import React, { useEffect, useState } from 'react';
import '../styles/BellaBizarreStyle.css';
import EventUploader from '../components/EventUploader';
import UploadMedia from '../components/UploadMedia';
// import ManageStoreEmbeds from '../components/StoreManager'; // unused
import StoreManager from '../components/StoreManager';
import HomePageEditor from '../components/HomePageEditor';
import { getAuth } from 'firebase/auth';
import AboutPageEditor from "../components/AboutPageEditor";

export default function BellaBizarreDashboard() {
    const [activeTab, setActiveTab] = useState('events');

    // Debug auth/claims safely (runs after mount)
    useEffect(() => {
        (async () => {
            try {
                const auth = getAuth();
                const u = auth.currentUser;
                if (!u) return;
                const t = await u.getIdTokenResult(true); // refresh claims
                console.log({
                    uid: u.uid,
                    email: u.email,
                    isAnonymous: u.isAnonymous,
                    provider: t?.claims?.firebase?.sign_in_provider,
                    claims: t?.claims,
                });
            } catch (e) {
                console.warn('claim debug failed', e);
            }
        })();
    }, []);

    return (
        <div className="event-uploader-container">
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
                <button
                    className={activeTab === 'home' ? 'event-uploader-submit-button' : 'event-uploader-submit-button'}
                    onClick={() => setActiveTab('home')}
                >
                    Home
                </button>
                        <button
                          className={activeTab === 'about' ? 'event-uploader-submit-button' : 'event-uploader-submit-button'}
                          onClick={() => setActiveTab('about')}
                        >
                          About
                        </button>
                <button
                    className={activeTab === 'events' ? 'event-uploader-submit-button' : 'event-uploader-submit-button'}
                    onClick={() => setActiveTab('events')}
                >
                    Manage Events
                </button>
                <button
                    className={activeTab === 'media' ? 'event-uploader-submit-button' : 'event-uploader-submit-button'}
                    onClick={() => setActiveTab('media')}
                >
                    Manage Media
                </button>
                <button
                    className={activeTab === 'store' ? 'event-uploader-submit-button' : 'event-uploader-submit-button'}
                    onClick={() => setActiveTab('store')}
                >
                    Manage Store
                </button>
            </div>
            {activeTab === 'home' && <HomePageEditor />}
            {activeTab === 'about' && <AboutPageEditor />}
            {activeTab === 'events' && <EventUploader />}
            {activeTab === 'media' && <UploadMedia />}
            {activeTab === 'store' && <StoreManager />}
        </div>
    );
}
